module.exports = __webpack_public_path__ + "img/icon-5.0c0ddc56.svg";